<template>
  <!-- PK 卡片: rank(排名PK, type=3) / disuse(淘汰PK, type=4) / single(单个战队或个人, type=2) -->
  <div class="pk-card" :class="`pk-card--${variant}`" v-if="info?.questionDetail">
    <div class="left-box">
      <div class="icon-bg">
        <div class="icon">
          <div
            class="head"
            :style="{ 'background-image': `url(${lg(objInfo, 'avatar', '')})` }"
          ></div>
          <div class="frame"></div>
        </div>
        <div class="name">
          <UiLabel shadow-color="rgba(0, 0, 0, 0.4)" text-color="#FFFFFF">
            {{ lg(objInfo, 'name', '-') }}
          </UiLabel>
        </div>
      </div>
    </div>
    <div class="middle-box">
      <div class="bg-deco"></div>
      <div class="question">
        <div class="title">
          <UiLabel shadow-color="#FFFFFF" text-color="#880000">
            {{ lg(info, 'questionDetail.title', '') }}
          </UiLabel>
        </div>
      </div>
      <div class="compared">
        <div class="inner">
          <div class="left-side" :class="{ 'is-zero': Number(odd.leftOdd) === 0 }" :style="{ width: `${odd.leftOdd}%` }"></div>
          <div class="right-side" :style="{ width: `${odd.rightOdd}%` }"></div>
        </div>
        <div class="desc left-desc">
          <UiLabel shadow-color="rgba(0, 0, 0, 0.4)" text-color="#fff">
            {{ odd.leftOdd || 0 }} % 支持
          </UiLabel>
        </div>
        <div class="desc right-desc">
          <UiLabel shadow-color="rgba(0, 0, 0, 0.4)" text-color="#fff">
            {{ odd.rightOdd || 0 }} % 支持
          </UiLabel>
        </div>
      </div>
      <div class="chooseList" v-if="lg(info, 'questionDetail.answers', []).length !== 0">
        <template
          v-for="(choose, index) in lg(info, 'questionDetail.answers')"
          :key="`choose-${lg(choose, 'answerCode', '')}`"
        >
          <div
            class="choose-item"
            @click="handleQuiz(info, info.questionDetail, choose, index)"
          >
            <div class="rate">赔率：{{ choose.lossRate }}</div>
            <div class="choose-btn" :class="index === 0 ? 'left-btn' : 'right-btn'">
              <UiLabel>{{ choose.answer }}</UiLabel>
            </div>
          </div>
          <div class="vs-icon" v-if="hasOpponent && index === 0"></div>
        </template>
      </div>
    </div>
    <div class="right-box" v-if="hasOpponent">
      <div class="icon-bg">
        <div class="icon">
          <div
            class="head"
            :style="{ 'background-image': `url(${lg(objInfo1, 'avatar', '')})` }"
          ></div>
          <div class="frame"></div>
        </div>
        <div class="name">
          <UiLabel shadow-color="rgba(0, 0, 0, 0.4)" text-color="#FFFFFF">
            {{ lg(objInfo1, 'name', '-') }}
          </UiLabel>
        </div>
      </div>
    </div>
    <div class="right-holder" v-else></div>
  </div>
</template>

<script setup>
import lg from '@/utils/lg'
import { ref, computed, watch, inject } from 'vue'
import UiLabel from '@/components/ui-label'

const handleQuiz = inject('handleQuiz')

const props = defineProps({
  info: { type: Object, default: () => ({}) },
  variant: {
    type: String,
    default: 'rank',
    validator: (v) => ['rank', 'disuse', 'single'].includes(v)
  }
})

const objInfo = ref({})
const objInfo1 = ref({})

// computed 兜底空数据 (原三兄弟 setup 顶层直接读 answers[0], 首帧无数据会 throw)
const odd = computed(() => ({
  leftOdd: Number(props.info?.questionDetail?.answers?.[0]?.popularity * 100).toFixed(0) || 0,
  rightOdd: Number(props.info?.questionDetail?.answers?.[1]?.popularity * 100).toFixed(0) || 0
}))

// 是否有第二个对手 (右边卡 + vs 图标共用此判断, 逻辑一致)
const hasOpponent = computed(() => {
  const code1 = lg(objInfo1.value, 'code')
  return code1 && code1 !== lg(objInfo.value, 'code')
})

watch(
  () => props.info,
  (newVal) => {
    if (newVal && newVal.questionDetail) {
      objInfo.value = newVal.questionDetail.objList[0] || {}
      objInfo1.value = newVal.questionDetail.objList[1] || {}
    }
  },
  { immediate: true, deep: true }
)
</script>

<style lang="scss" scoped>
.pk-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: get_vw(246);
  .left-box, .right-box {
    box-sizing: border-box;
    width: get_vw(158);
    margin-inline: get_vw(24);
    display: flex;
    align-items: center;
    height: 100%;
    .icon-bg {
      width: 100%;
      height: get_vw(194);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      background: url(https://website.xdcdn.net/poster/58881/26match/common/Q3eEky6t.jpg) center/100% 100% no-repeat;
      .icon {
        position: relative;
        width: get_vw(120);
        height: get_vw(130);
        @include avatar_icon_frame;
        margin-top: get_vw(12);
        margin-bottom: get_vw(14);
      }
      .name {
        font-size: get_vw(20);
      }
    }
  }
  .left-box { justify-content: flex-end; }
  .right-box { justify-content: flex-start; }
  .right-holder {
    width: get_vw(36);
    height: 100%;
    opacity: 0;
  }

  .middle-box {
    box-sizing: border-box;
    position: relative;
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  .question {
    position: relative;
    z-index: 1;
    width: 100%;
    height: get_vw(72);
    display: flex;
    justify-content: center;
    align-content: center;
    margin: 0 auto;
    .title {
      width: 81%;
      font-size: get_vw(24);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  }

  .compared {
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    width: 100%;
    height: get_vw(54);
    border-radius: get_vw(27);
    background-color: #D7DAE7;
    border: get_vw(2) solid #FFFFFF;
    .inner {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: get_vw(27);
      .left-side {
        width: 50%;
        height: 100%;
        background: linear-gradient(90deg, #D0AB55, #EDCFA2);
        border-right: get_vw(2) solid #FFFFFF;

        // 两边都 0 时 left-side width 是 0, border-right 仍占位显示为最左侧一根白线, 避开
        &.is-zero {
          border-right: 0;
        }
      }
      .right-side {
        width: 50%;
        height: 100%;
        background: linear-gradient(90deg, #CD2224, #A6070D);
      }
    }
    .desc {
      position: absolute;
      top: 50%;
      font-size: get_vw(20);
      transform: translate3d(0, -50%, 0);
      &.left-desc { left: get_vw(26); }
      &.right-desc { right: get_vw(26); }
    }
  }

  .chooseList {
    position: relative;
    z-index: 1;
    width: 100%;
    height: get_vw(77);
    margin-top: get_vw(26);
    box-sizing: border-box;
    padding-inline: get_vw(24);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .choose-item {
      position: relative;
      min-width: get_vw(92);
      width: auto;
      height: 100%;
      font-size: get_vw(20);
      font-weight: bold;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      .rate {
        position: relative;
        color: #333;
        line-height: get_vw(28);
        white-space: nowrap;
        font-weight: 500;
      }

      .choose-btn {
        width: 100%;
        height: get_vw(44);
        padding-inline: get_vw(12);
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;

        // 左按钮 (原 ui-button color-yellow 变体)
        &.left-btn {
          background: url(https://website.xdcdn.net/poster/58881/26match/common/QQhazoyh.png) center/100% 100% no-repeat;
          --label-shadow-color: #423824;
          --label-text-color: #fff;
        }

        // 右按钮 (原 ui-button color-blue 变体)
        &.right-btn {
          background: url(https://website.xdcdn.net/poster/58881/26match/common/QU115pc4.png) center/100% 100% no-repeat;
          --label-shadow-color: #6b0308;
          --label-text-color: #fff;
        }
      }
    }

    .vs-icon {
      align-self: flex-end;
      width: get_vw(92);
      height: get_vw(62);
      background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/QZDeVlxf.png);
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  .bg-deco {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    pointer-events: none;
    width: get_vw(540);
    height: get_vw(141);
    background: url(https://website.xdcdn.net/poster/58881/26match/common/QZFiqdtq.png) center/cover no-repeat;
    mix-blend-mode: soft-light;
  }
}
</style>
